import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDistanceToRough = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.5 5 43 27.5 35 43H12.5l-3.216-9.86q7.734 8.66 7.745 8.67a.68.68 0 0 0 .983-.041l15.803-17.7a.738.738 0 0 0 .052-.91l-5.321-7.565a1.4 1.4 0 0 0-.494-.437A1.36 1.36 0 0 0 27.42 15H8.703L5 20l4.284 13.14-8.1-9.073a.737.737 0 0 1-.052-.91l5.322-7.565c.13-.183.299-.332.494-.435.196-.103.412-.157.631-.157h1.124L16.11 5z" })
});
export default SvgDistanceToRough;
